import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { LogoComponent } from '../Logo';

export interface CheckoutSuccessProps {
  children?: React.ReactNode;
  product?: any;
}

export const CheckoutSuccessComponent: React.FC<CheckoutSuccessProps> = ({ children, product }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isTrueSight = !!product?.name && product.name.toLowerCase() === 'true sight';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        bgcolor: 'white',
        width: isMobile ? '100%' : '500px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <LogoComponent hasOnlyIcon />
        {isTrueSight ? (
          <Typography variant="h6" textAlign="center" sx={{ paddingTop: 'var(--content-spacing)' }}>
            Thank you for your True Sight order. <br /> Your project is now being processed and may take up to
            one working day to complete. You can safely close this page — processing will continue in the
            background. We’ll send you an email as soon as your results are ready.
          </Typography>
        ) : (
          <Typography variant="h6" textAlign="center" sx={{ paddingTop: 'var(--content-spacing)' }}>
            Thank you for submitting a quote request. <br /> A member of our team will be in touch shortly.
          </Typography>
        )}
        <Typography sx={{ fontSize: '12px', padding: 'var(--content-spacing)' }} textAlign="center">
          You can contact us at <a href="mailto:sales@gentian.io"> sales@gentian.io</a> for any questions.
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

//the one being used
